module.exports = __webpack_public_path__ + "static/3_3_spam-or-ham_HR-f3361aaa53c993029ba22d608b713e66.svg";